import type {Lead} from 'types/entities/Lead'

/** Data-only snapshot, safe to use in reducers without loading services or the store. */
export const opportunityAddressKey = (lead: Lead): string => JSON.stringify([
    lead.hall_id, lead.source, lead.company?.id, lead.company?.default_address_id,
    lead.company?.street_address, lead.company?.postal_code, lead.company?.city,
    lead.company?.country, lead.company?.state, lead.state,
    lead.company?.addresses?.map(address => [address.id, address.company_id,
        address.street_name, address.postal_code, address.town, address.country,
        address.region, address.deleted_at]),
])
